import { IGetServiceProps } from "@api/types/globalService.types";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import URLS from "@api/constants/urls";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import { useSearchParams } from "react-router-dom";

export const useGetAllBranchesServices = ({
  page = "1",
  per_page = "15",
  enableQuery = true,
}: IGetServiceProps) => {
  const [branchesSearchQuery, setBranchesSearchQuery] = useState("");
  const { debouncedQuery } = useGlobalDebounceHandler(branchesSearchQuery);
  const [searchParams] = useSearchParams();
  const partnerId = searchParams.get("partner-id") || false;
  const hasPartnerId = !!partnerId;

  const allBranchesServices = useQuery({
    queryKey: [
      ...CACHE_KEYS.BRANCHES,
      page,
      per_page,
      debouncedQuery,
      hasPartnerId ? partnerId : "",
    ],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.BRANCHES,
        searchParams: {
          page,
          per_page,
          "filter[name]": debouncedQuery,
          include: "city,state,manager,partner",
          ...(hasPartnerId && { "filter[partner_id]": partnerId }),
        },
      }),
    enabled: enableQuery,
  });
  return {
    services: { allBranchesServices },
    states: { branchesSearchQuery, setBranchesSearchQuery },
  };
};
